import React from 'react';
import PageHero from './componenets/PageHero';
import Reveal from './componenets/Reveal';

const slides = ['GOP_FundraisingInfo_P1.png','GOP_FundraisingInfo_P2.png','GOP_FundraisingInfo_P3.png','GOP_FundraisingInfo_P3.5.png','GOP_FundraisingInfo_P4.png','GOP_FundraisingInfo_P5.png','GOP_FundraisingInfo_P6.png','GOP_FundraisingInfo_P7.png'];

export const FundraisingInfo = () => (
  <div className="site-page">
    <PageHero eyebrow="Project resources" title="Fundraising Information" description="Information about the Garden of Peace project and its fundraising needs." image="/images/HomeSlider_4.jpg" compact />
    <section className="site-section site-section--sage"><div className="site-container document-stack">{slides.map((slide,index)=><Reveal key={slide} delay={(index % 2) * 60}><img src={'/images/' + slide} alt={'Garden of Peace fundraising information, page ' + (index + 1)} loading="lazy" /></Reveal>)}</div></section>
  </div>
);
